import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ComplaintV1Status, ComplaintV1Statuses, ComplaintV1StatusesColors } from '@icc/b2b/shared';

@Component({
    selector: 'icc-complaint-v1-status',
    templateUrl: './complaint-v1-status.component.html',
    styles: [':host { display: inline-block; }'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComplaintV1StatusComponent {
    private _status: ComplaintV1Status;

    @Input()
    get status(): ComplaintV1Status {
        return this._status;
    }
    set status(value: ComplaintV1Status) {
        this._status = value;
        this.colorRgbHex = ComplaintV1StatusesColors[value];
        this.name = ComplaintV1Statuses[value];
    }

    colorRgbHex = '';
    name = '';
}
